const fn = '[cynqueModules/utils/format24As12.ts] format24As12 |'

// Pure formatter extracted (minus the inline console.debug noise) from
// plugins/format24As12.ts so callers can format without the removed Nuxt-2
// `window.$nuxt.$format24As12` global. The plugin now delegates here, and
// TimeVTextField imports it directly.
export function format24As12(value: string | null): string | null {
  if (value === null) {
    return value
  }
  if (!value) {
    return null
  }

  // Already 12-hour (e.g. '01:30 PM') — leave it unchanged.
  const twelveHour = /^(((0[1-9])|(1[0-2])):([0-5])([0-9])\s(A|P)M)$/
  if (twelveHour.test(value)) {
    return value
  }

  // Otherwise it must be 24-hour (e.g. '13:30' / '1:30').
  const twentyFourHour = /^(?:\d|[01]\d|2[0-3]):[0-5]\d$/
  if (!twentyFourHour.test(value)) {
    return null
  }

  const timeArray = value.split(':')
  if (!timeArray || timeArray.length < 2) {
    console.error(`${fn} invalid value:`, value, '. returning null.')
    return null
  }

  const rawHours = parseInt(timeArray[0])
  const hours = rawHours % 12 || 12
  const amOrPm = rawHours >= 12 ? 'PM' : 'AM'
  return `${hours}:${timeArray[1]} ${amOrPm}`
}
